import { safeParseJSON } from 'utils/helpers';
import type { ApplicationUser } from 'types/company/applicationUser';

/**
 * האם המשתמש מסומן "מוצג ברשימת משתמשים" (העמודה במסך /users).
 * הדגל נשמר ב-ProfileConfig.funnerInfo.visibleInList; כשלא הוגדר מעולם — נופלים ל-IsActive.
 * אותה סמנטיקה שמשוכפלת אינליין במסכי הפילטרים/שיוך — מקור אחד לשימוש חדש.
 */
export function isApplicationUserVisibleInList(user: ApplicationUser): boolean {
  const profileConfig = safeParseJSON(user.ProfileConfig);
  const visible = profileConfig?.funnerInfo?.visibleInList;
  if (visible !== undefined && visible !== null) return Boolean(visible);
  return Boolean(user.IsActive);
}
